// packages/components/src/admin/users/AddCreditsModal.tsx
import React, { useState } from 'react';
// --- ADD Spinner to imports ---
import { Modal, TextField, Button, TextareaField, Spinner, Icon } from '@dopomogai/ui';

interface AddCreditsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (amount: number, description: string) => Promise<void>;
  userName: string;
}

export const AddCreditsModal: React.FC<AddCreditsModalProps> = ({ isOpen, onClose, onSave, userName }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount) || numericAmount <= 0 || description.trim().length < 5) {
      alert('Please enter a valid positive amount and a description (min 5 characters).');
      return;
    }
    setIsSaving(true);
    await onSave(numericAmount, description);
    // The parent component will close the modal on success, so we don't need to reset state here if it does.
    // However, keeping it is safer in case the parent logic changes.
    setIsSaving(false);
  };
  
  const handleClose = () => {
    setAmount('');
    setDescription('');
    setIsSaving(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={`Add Credits to ${userName}`}>
      <div className="p-6 space-y-4">
        <TextField 
          label="Amount to Add ($)"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="e.g., 100.00"
          disabled={isSaving} // Disable input while saving
        />
        <TextareaField 
          label="Reason / Description (Required)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="e.g., Manual grant for beta testing feedback"
          rows={3}
          disabled={isSaving} // Disable textarea while saving
        />
        <div className="flex justify-end gap-3 pt-4">
          <Button text="Cancel" variant="secondary" onClick={handleClose} disabled={isSaving} />
          {/* --- CORRECTED USAGE OF Button FOR LOADING STATE --- */}
          <Button 
            text="Add Credits" 
            onClick={handleSave} 
            disabled={isSaving} // Disable the button while saving
            icon={isSaving ? <Spinner size="sm" /> : <Icon name="PlusCircle" />} // Conditionally show Spinner
            iconPosition="left"
          />
        </div>
      </div>
    </Modal>
  );
};